import { BezierEdge, EdgeProps, Position, getBezierPath } from '@xyflow/react';

export function CustomEdge(props: EdgeProps) {
  return <BezierEdge {...props} interactionWidth={60} style={{ strokeWidth: 4 }} />;
}

export const ConnectionLine = ({
  fromX,
  fromY,
  toX,
  toY,
  fromPosition,
  toPosition,
}: {
  fromX: number;
  fromY: number;
  toX: number;
  toY: number;
  fromPosition: Position;
  toPosition: Position;
}) => {
  const [edgePath] = getBezierPath({
    sourceX: fromX,
    sourceY: fromY,
    sourcePosition: fromPosition,
    targetX: toX,
    targetY: toY,
    targetPosition: toPosition,
  });

  return (
    <g>
      <path fill="none" stroke="#A3A7C2" strokeWidth={1.5} className="animated" d={edgePath} />
      <circle cx={toX} cy={toY} fill="#fff" r={4} stroke="#705BFF" strokeWidth={1.5} />
    </g>
  );
};
